import React, { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import InfoBox from "common-ui-components/components/info-box/InfoBox";
import InfoBoxRedirectButton from "app/common/InfoBoxRedirectButton";
import Summary from "app/patch/view/patch-db/tabs/summary/Summary";
import styles from "./PatchOverviewPanel.module.css";

const PatchCatalogOverview = () => {
  const navigate = useNavigate();
  const [summary, setSummary] = useState(null);
  const handleSummaryChange = useCallback((value) => {
    setSummary(value);
  }, []);
  const formatDate = (value) => {
    if (!value) return "--";
    const date = new Date(value);
    return Number.isNaN(date.getTime())
      ? value
      : date.toLocaleString([], {
          month: "short",
          day: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "2-digit",
        });
  };
  const syncStatus =
    summary?.syncStatus === "UP_TO_DATE"
      ? "Sync successful"
      : summary?.syncStatus === "FAILED"
        ? "Sync failed"
        : summary?.syncStatus
          ? summary.syncStatus.replace(/_/g, " ")
          : undefined;
  const syncBadgeColor =
    summary?.syncStatus === "FAILED"
      ? { background: "#fee8e7", color: "#b42318" }
      : { background: "#e2f7ed", color: "#047857" };

  return (
    <InfoBox
      header="Vulnerability & Patch Catalog"
      subtitle={
        summary
          ? `Last synced: ${formatDate(summary.lastSyncedAt)}${
              summary.timeUntilNextSync
                ? ` · Next auto-sync in ${summary.timeUntilNextSync}`
                : ""
            }`
          : "Patch database status and recent synchronization history"
      }
      badge={
        <div className={styles.catalogBadge}>
          {syncStatus && (
            <span className={styles.catalogStatusBadge} style={syncBadgeColor}>
              {syncStatus}
            </span>
          )}
          <InfoBoxRedirectButton
            onClick={() => navigate("/app/secure/settings/db-sync")}
            label="Open vulnerability and patch catalog"
          />
        </div>
      }
      badgeProps={{ className: styles.catalogBadgeContainer }}
      style={{ minWidth: 0, gridColumn: "1 / -1" }}
      childrenProps={{
        className: `${styles.panelContent} ${styles.catalogContent}`,
      }}
    >
      <Summary compact onSummaryChange={handleSummaryChange} />
    </InfoBox>
  );
};

export default PatchCatalogOverview;
